import React from 'react';
import { FaImage, FaTimes, FaMusic } from 'react-icons/fa';
import MusicPicker from '../MusicPicker';
import PhotoFilters from './PhotoFilters';

const PointForm = ({
  content, setContent, isVideo,
  mediaFile, mediaPreview, handleMediaChange, clearMedia,
  showMusicPicker, setShowMusicPicker,
  selectedMusic, setSelectedMusic,
  onFilterChange,
}) => (
  <>
    <div>
      <label className="text-sm text-gray-600 mb-2 block">What&apos;s on your mind?</label>
      <textarea
        data-testid="post-content-input"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="w-full bg-gray-100 border border-gray-300 focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] rounded-lg p-4 text-gray-900 placeholder:text-gray-400 transition-all outline-none min-h-[100px] resize-none"
        placeholder="Share your thoughts..."
        required
      />
    </div>

    <div>
      <label className="text-sm text-gray-600 mb-2 block">{isVideo ? 'Add Video (Required)' : 'Add Media (Optional)'}</label>
      {mediaPreview ? (
        <>
          {/* Show inline preview only for video; photos shown via PhotoFilters */}
          {mediaFile?.type?.startsWith('video') ? (
            <div className="relative">
              <video src={mediaPreview} className="w-full rounded-lg max-h-48 object-cover" controls />
              <button type="button" onClick={clearMedia} className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600"><FaTimes size={12} /></button>
            </div>
          ) : (
            <div className="relative">
              <button type="button" onClick={clearMedia} className="absolute top-2 right-2 z-10 bg-red-500 text-white rounded-full p-2 hover:bg-red-600"><FaTimes size={12} /></button>
              <PhotoFilters mediaPreview={mediaPreview} onFilterChange={onFilterChange} />
            </div>
          )}
        </>
      ) : (
        <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-6 cursor-pointer hover:border-[#4A90E2]/50 transition-colors">
          <FaImage className="text-3xl text-gray-400 mb-2" />
          <p className="text-gray-500 text-sm">{isVideo ? 'Click to upload video' : 'Click to upload'}</p>
          <input type="file" accept={isVideo ? 'video/*' : 'image/*,video/*'} onChange={handleMediaChange} className="hidden" data-testid="media-upload-input" />
        </label>
      )}
    </div>

    {/* Music Picker */}
    <div>
      {selectedMusic ? (
        <div className="flex items-center space-x-3 bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-xl p-3" data-testid="selected-music-preview">
          <img src={selectedMusic.album_art} alt={selectedMusic.song_title} className="w-10 h-10 rounded-lg object-cover" />
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-1.5">
              <FaMusic className="text-[10px] text-[#4A90E2]" />
              <p className="text-sm font-medium text-gray-900 truncate">{selectedMusic.song_title}</p>
            </div>
            <p className="text-xs text-gray-500">{selectedMusic.artist}</p>
          </div>
          <button type="button" onClick={() => setSelectedMusic(null)} className="text-gray-400 hover:text-red-500 p-1" data-testid="remove-music-btn"><FaTimes size={14} /></button>
        </div>
      ) : showMusicPicker ? (
        <MusicPicker
          selectedTrack={selectedMusic}
          onSelect={(track) => { setSelectedMusic(track); setShowMusicPicker(false); }}
          onClose={() => setShowMusicPicker(false)}
        />
      ) : (
        <button
          type="button"
          onClick={() => setShowMusicPicker(true)}
          className="w-full flex items-center justify-center space-x-2 py-3 border-2 border-dashed border-gray-200 rounded-xl text-gray-500 hover:border-[#4A90E2]/50 hover:text-[#4A90E2] transition-colors"
          data-testid="add-music-btn"
        >
          <FaMusic size={14} />
          <span className="text-sm font-medium">Add Music from</span>
          <img src="/gdme-logo.svg" alt="GDME" className="h-4" />
        </button>
      )}
    </div>
  </>
);

export default PointForm;
